// removed by extract-text-webpack-plugin
module.exports = {"component":"Tbh9AEwfkb16aOXvUw6Eg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Coupon/CouponPrice/couponPrice.css
// module id = 1097
// module chunks = 2